// TODO: 整理

import { FavoriteButton } from './FavoriteButton';
import { ReferenceQuestion } from './ReferenceQuestion';

(function(){
  const triggerClass = ".js-switchListView";
  const $allTrigger = $(triggerClass);
  const $list = $(".js-switchListViewTarget");
  const dataName = "data-list-view-type";
  let type = "grid";
  let currentTrigger = null;

  $(function(){
    type = $list.attr(dataName);
    currentTrigger = `${triggerClass}[${dataName}="${type}"]`;
    $(currentTrigger).addClass("is-active");
  })

  $allTrigger.on("click", function(){
    type = $(this).attr(dataName);
    currentTrigger = `${triggerClass}[${dataName}="${type}"]`;
    $list.attr(dataName, type);
    $allTrigger.removeClass("is-active");
    $(currentTrigger).addClass("is-active");
  });

})();

(function(){
  window.addEventListener('DOMContentLoaded', function(e){
    const searchForms = document.querySelectorAll('.js-form_search_product_blogs');
    searchForms.forEach(function(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        const target = e.target;
        const value = target.querySelector('select').value;
        if (value === "") {
          return false;
        }
        const url = target.getAttribute('action') + value;
        location.href = url;
      });
    });
  });
})();

(function(){
  window.addEventListener('DOMContentLoaded', function(e){
    const favoriteButtons = document.querySelectorAll('.js-article-post-favorite');

    if (favoriteButtons.length) {
      const addFavoritePath = "/api/post_favorites";
      Array.from(favoriteButtons).map(btn => {
        return new FavoriteButton(btn, addFavoritePath);
      });
    };
  });
})();

(function(){
  window.addEventListener('DOMContentLoaded', function(e){
    const elm = document.querySelector('.js-post-reference-question');

    if (elm) {
      new ReferenceQuestion(elm);
    };
  });
})();
